import { useEffect, useRef, useState } from 'react';
import { ButtonGroup, IconButton, Whisper, Tooltip } from 'rsuite';
import { useTranslation } from 'react-i18next';
import ThemeButton from '@shared/ui/buttons/ThemeButton';
import { icons } from '@shared/static/icons';
import { copyToClipboard } from '@utils/helpers';

export default function SplitButtonCopy({
  value,
  text,
  icon,
  href,
  appearance = 'secondary',
  disabled = false,
}) {
  const { t } = useTranslation();
  const whisperRef = useRef();
  const timerRef = useRef();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const copy = async () => {
    try {
      await copyToClipboard(value);
    } catch {
      return;
    }
    setIsCopied(true);
    whisperRef.current?.open();
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsCopied(false);
      whisperRef.current?.close();
    }, 1000);
  };

  return (
    <ButtonGroup divided className="split-btn">
      <ThemeButton
        as="a"
        href={href}
        appearance={appearance}
        startIcon={icon}
        disabled={disabled}
      >
        <p className="text-overflow">{text}</p>
      </ThemeButton>
      <Whisper
        ref={whisperRef}
        placement="auto"
        preventOverflow
        trigger="none"
        speaker={<Tooltip>{t('copied_to_clipboard')}</Tooltip>}
      >
        <IconButton
          appearance={appearance}
          icon={icons[isCopied ? 'check' : 'copy']}
          onClick={copy}
          disabled={disabled}
        />
      </Whisper>
    </ButtonGroup>
  );
}
